// extracted by mini-css-extract-plugin
export default {"button":"Button_button__G-OVk","disabled":"Button_disabled__1nflu","primary":"Button_primary__rCU4G","secondary":"Button_secondary__YTEbo","dense":"Button_dense__hL5vA"};